<template>
  <div
    ref="leaflet_container"
    class="leaflet-container"
    :style="{
      width: width,
      height: height,
      zIndex: 0,
    }"
    :class="{
      'home-map': homeMap,
    }"
    v-bind="attrs"
  >
  </div>
  <MapSearch
    v-if="checkMap && search"
    :map="checkMap"
  />

</template>

<script setup>
import {
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick, useAttrs,
} from 'vue'
import MapSearch from './component/MapSearch'
import store from '@/store/index'
import { isNull, dayjs, message } from '@/utils/js/initVariable'
import { mapBaseLayers } from '@/utils/js/leafletUtils'

// console.log(store)
const mapBoxToKen = store.getters.getMapBoxToken,
      mapBoxURL = store.getters.getMapBoxURL
// console.log(mapBoxToKen, mapBoxURL, mapConfig)

// props
const props = defineProps({
  map_config: { type: Object, default: ()=>{ return store.getters.getMapConfig } },
  layerControl: { type: Boolean, default: ()=>{ return false }, },
  height: { type: String, default: ()=>{ return '100%' }, },
  width: { type: String, default: ()=>{ return '100%' }, },
  search: { type: Boolean, default: ()=>{ return false }, },
  homeMap: { type: Boolean, default: ()=>{ return false }, },
  isAddBaseLayer: { type: Boolean, default: ()=>{ return false }, },
  preferCanvas: { type: Boolean, default: ()=>{ return false }, },
  isDragging: { type: Boolean, default: ()=>{ return true }, },
  zoomShow: { type: Boolean, default: ()=>{ return true }, },
  isShowInfoControl: { type: Boolean, default: ()=>{ return true }, },
  scrollWheelZoom: { type: Boolean, default: ()=>{ return true }, },
})
// emit
const emit = defineEmits([
  'mapInit',
])

// 组件挂载前
onBeforeMount(()=>{

})
// 组件挂载后
onMounted(()=>{
  nextTick(()=>{
    mapInit()
  })
})
// 组件更新后
onUpdated(()=>{
})
// 组件销毁后
onUnmounted(()=>{
  if (map) {
    map.off('zoomend', handleZoomEnd);
    map.off('mousemove', mousemoveEvent);
    map.off('baselayerchange', baselayerchangeEvent);
    L.DomEvent.off(map.getContainer(), 'wheel', wheelEvent);
  }
})

const attrs = useAttrs();

let leaflet_container = ref(),
    map = null, checkMap = ref(null)
let handleZoomEnd, wheelEvent = (e)=>{
    L.DomEvent.stopPropagation(e);
    const zoomlevel = map.getZoom() + (e.deltaY < 0 ? 0.3 : -0.3);
    // const clientX = e['clientX'], clientY = e['clientY'],
    //       point = L.point(clientX, clientY),
    //       center = map.layerPointToLatLng(point);
    // layerPointToLatLng
    // map.setZoom(zoomlevel);
    map.setZoomAround(center, zoomlevel);
    // map.flyTo(center, zoomlevel, {
    //   // animate: true,
    // });
  }
let center = L.latLng(props.map_config.center),
    mousemoveEvent = (e)=>{
      center = e.latlng;
    }
let baselayer,
baselayerchangeEvent = (event)=>{
  baselayer = event.layer;
  event.name === '自适应卫星底图' ? map.on('zoomend', handleZoomEnd) : map.off('zoomend', handleZoomEnd)
}

const mapInit = () => {
  const baseLayers = mapBaseLayers(true, props.map_config)
  const layers = props.isAddBaseLayer ? [baseLayers['自适应卫星底图']] : []
  map = L.map(leaflet_container.value, {
    zoomControl: false,
    center: props.map_config.center,
    zoom: props.map_config.zoom,
    minZoom: props.map_config.minZoom,
    maxZoom: props.map_config.maxZoom,
    layers,
    worldCopyJump: false,
    preferCanvas: props.preferCanvas,
    maxBounds:[
      [90,540],
      [-90,540],
      [-90,-540],
      [90,-540]
    ],
    attributionControl: false,
    // zoom ±0.1
    scrollWheelZoom: props.scrollWheelZoom,
    zoomSnap: props.scrollWheelZoom?1:0.1,
    dragging: props.isDragging,

    // zoomAnimation: false,
  })

  if (props.layerControl) {
    L.control.layers(baseLayers, null, {
      // position: "topleft",
      /*collapsed: false*/
    }).addTo(map)
  }
  if(props.zoomShow){
    L.control.zoom({
      position: 'topright',
    }).addTo(map)
  }

  if(props.isShowInfoControl){
    L.control.mousePosition({
      position: "bottomright",
    }).addTo(map)

    L.control.scale({
      position: "bottomright", imperial: false ,
    }).addTo(map)
  }

  if(props.isAddBaseLayer){
    if(__IS__OFFLINE__){
      handleZoomEnd = ()=>{}
    }else{
      handleZoomEnd = (e) => {
        const zoomLevel = map.getZoom();
        if (zoomLevel >= 9) {
          if(map.hasLayer(baseLayers['自适应卫星底图'])){
            map.removeLayer(baseLayers['自适应卫星底图']);
            map.addLayer(baseLayers['高清卫星地图']);
            baselayer = baseLayers['自适应卫星底图'];
          }
        }else{
          if(map.hasLayer(baseLayers['高清卫星地图']) && baselayer == baseLayers['自适应卫星底图']){
            map.removeLayer(baseLayers['高清卫星地图']);
            map.addLayer(baseLayers['自适应卫星底图']);
          }
        }
        // else {
        //   map.removeLayer(baseLayers['高清卫星地图']);
        //   map.addLayer(baseLayers['自适应卫星底图']);
        // }
      };
    }
  }else{
    handleZoomEnd = (e) => {}
  }

  map.on('mousemove', mousemoveEvent)
  map.on('zoomend', handleZoomEnd)
  map.on('baselayerchange', baselayerchangeEvent)
  if(!props.scrollWheelZoom){
    L.DomEvent.on(map.getContainer(), 'wheel', wheelEvent, {
      passive: true,
      capture: true,
    });
  }
  // handleZoomEnd();
  emit('mapInit', map)
  checkMap.value = map
}
// const tileName = computed(() => store.state.tileName)
// watch(tileName, (newVal) => {
//   newVal === '自适应卫星底图' ? map.on('zoomend', handleZoomEnd) : map.off('zoomend', handleZoomEnd)
// })
</script>

<style lang='less'>

</style>

<style lang='less' scoped>
</style>
